'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = combineReducers;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isCombinedReducer = Symbol('@@isCombinedReducer');

function combineReducers() {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  var cache = new Map();
  var seen = new Set();

  // get cached reducers
  reducers = reducers.reduce(function (reducers, reducer) {
    var _reducer = reducer;
    if (reducer && reducer[isCombinedReducer]) {
      // if is an empty combinedReducer, filter out
      _reducer = reducer.getCached();
    }
    return reducers.concat(_reducer);
  }, []);

  // check the reducers
  reducers.forEach(function (reducer) {
    !(typeof reducer === 'function') ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'reducers should be functions but found ' + reducer) : (0, _invariant2.default)(false) : void 0;
    !(reducer.toString !== Function.prototype.toString) ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'reducers must have a user defined toString function.\n      check the reducer ' + reducer) : (0, _invariant2.default)(false) : void 0;
  });

  // filter out duplicates
  reducers = reducers.filter(function (r) {
    return seen.has(r.toString()) ? false : seen.add(r.toString());
  });

  // save reducers in cache
  reducers.forEach(function (r) {
    return cache.set(r.toString(), r);
  });

  // create final reducer
  function finalReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var hasChanged = false;
    var nextState = {};
    var numOfReducers = reducers.length;
    for (var i = 0; i < numOfReducers; i++) {
      var reducer = reducers[i];
      var previousStateForKey = state[reducer];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        throw new Error('got undefined state for ' + reducer);
      }
      nextState[reducer] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  }

  // mark as a combinedReducer
  finalReducer[isCombinedReducer] = true;

  finalReducer.getCached = function () {
    return Array.from(cache.values());
  };

  return finalReducer;
}


//////////////////
// WEBPACK FOOTER
// ./~/berkeleys-redux-utils/lib/combine-reducers.js
// module id = 567
// module chunks = 168707334958949